// Mirrors PASSWORD_POLICY_REGEX in the backend (validations/credentialsValidation.js).

export interface PasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: "length", label: "At least 8 characters", test: (pw) => pw.length >= 8 },
  { id: "lower", label: "A lowercase letter", test: (pw) => /[a-z]/.test(pw) },
  { id: "upper", label: "An uppercase letter", test: (pw) => /[A-Z]/.test(pw) },
  { id: "number", label: "A number", test: (pw) => /\d/.test(pw) },
  { id: "symbol", label: "A symbol, like ! or #", test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export const PASSWORD_POLICY_MESSAGE =
  "Use at least 8 characters with an uppercase letter, a lowercase letter, a number and a symbol.";

export const meetsPasswordPolicy = (password: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(password));
